"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/hooks");
var ConnectionErrorMsg = function (_a) {
    var errorMessage = _a.errorMessage;
    var provider = (0, hooks_1.useQParam)('provider');
    var accountingSystem = (0, end2end_1.getProviderAsNice)(provider);
    var SUPPORT_HREF = "mailto:".concat(end2end_1.HUDLED_EMAILS.support, "?subject=Failed to connect to ").concat(accountingSystem || 'my accounting platform');
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, mb: 1, color: "inherit" }, { children: ["We tried to connect to ", accountingSystem || 'your accounting platform', ", but we received an error. Try again and if you can\u2019t connect, get in touch with us", ' ', "at ", (0, jsx_runtime_1.jsx)("a", __assign({ href: SUPPORT_HREF }, { children: end2end_1.HUDLED_EMAILS.support })), " to report this error"] })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, color: "inherit" }, { children: ["Error: ", errorMessage.toUpperCase()] }))] }));
};
exports.default = ConnectionErrorMsg;
